import React from 'react';
import HashLink from 'components/HashLink';
import Modal from 'components/Modal';
import API from 'utils/API';
import androidAppIcon from '../images/android-app.png';

import './style.scss';

export type AppLinkType = 'ios' | 'android';

interface AppLinkProps {
    imgSrc?: string; // 图片地址
    type: AppLinkType; // 平台类型
    className?: string;
    url: string; // 跳转链接
}

const ModalAndroid = () => {
    return (
        <div className="android-links-modal">
            <a
                className="google-play"
                href={`${API.CUSTOMER.appLink()}?platform=android&app_name=TradeUP&lang=en_US`}
                target="view_window">
                <img src={androidAppIcon} className="img-responsive" alt="googlePlay" />
            </a>
            <hr />
            <a className="apk" download href="https://tigr.link/5kWt5N" target="view_window">
                {__('Download APK (for advanced users)')}
            </a>
        </div>
    );
};

const AppLink: React.FC<AppLinkProps> = props => {
    const { imgSrc, type, className, url } = props;

    const handleAndroid = () => {
        Modal.open({
            component: ModalAndroid,
            maskClosable: true
        });
    };

    if (type === 'android') {
        return (
            <HashLink onClick={handleAndroid} className={`applink-root ${className}`}>
                <img src={imgSrc} alt={`download ${type} app`} />
            </HashLink>
        );
    }

    return (
        <a href={url} target="view_window" className={`applink-root ${className}`}>
            {!!imgSrc && <img src={imgSrc} alt={`download ${type} app`} />}
        </a>
    );
};

export default AppLink;
